import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = {
    target: String
  }

  connect() {
    // Initialize with hidden content
  }

  toggle(event) {
    event.preventDefault()

    const targetId = this.hasTargetValue ? this.targetValue : event.currentTarget.dataset.toggleTargetValue
    const element = document.getElementById(targetId)

    if (element) {
      element.classList.toggle('hidden')
    }
  }
}
